import React from "react";

import {
  FaPlus,
  FaTimes,
} from "react-icons/fa";

import AddViajeForm from "./AddViajeForm";

const AddViaje = ({
  show,
  setShow,
}) => {
  const handleShow = () => {
    setShow(!show);
  };

  return (
    <>
      <div className="ren2-add-row">
        <button
          type="button"
          className={
            show
              ? "ren2-add-button ren2-add-button-cancel"
              : "ren2-add-button"
          }
          onClick={handleShow}
        >
          {show ? (
            <>
              <FaTimes />
              Cancelar
            </>
          ) : (
            <>
              <FaPlus />
              Nueva rendición
            </>
          )}
        </button>
      </div>

      {show && (
        <div className="ren2-add-form">
          <AddViajeForm
            setShow={setShow}
          />
        </div>
      )}
    </>
  );
};

export default AddViaje;